
// Generated with baseline-styles - Do not modify.
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.styles = {
    "text": "text-9ec1dc19",
    "ellipsize": "ellipsize-9ec1dc19",
    "fit": "fit-9ec1dc19"
};
exports.styleSource = ".text-9ec1dc19{position:relative}.ellipsize-9ec1dc19{width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.fit-9ec1dc19{position:absolute;top:0;left:0;width:100%;height:100%}";
exports.default = exports.styles;
            
module.moduleType = "style";
